module.exports = __webpack_public_path__ + "img/logo.9bfdc634.svg";